import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
    // React 18 conflict between concurrent renders + Radix Portals can throw
    // `insertBefore` / `removeChild` errors. They're transient — try to auto-recover.
    const msg = String(error?.message || "");
    if (msg.includes("removeChild") || msg.includes("insertBefore") || msg.includes("not a child of this node")) {
      setTimeout(() => this.setState({ hasError: false, error: null }), 60);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily: "system-ui, sans-serif",
        }} data-testid="global-error-boundary">
          <div style={{
            maxWidth: 520, padding: 24, borderRadius: 12,
            background: "rgba(255,0,0,0.05)", border: "1px solid rgba(255,0,0,0.2)",
            textAlign: "center",
          }}>
            <div style={{ fontSize: 40 }}>⚠️</div>
            <h2 style={{ margin: "8px 0" }}>Algo deu errado nessa tela.</h2>
            <p style={{ opacity: 0.7, fontSize: 14 }}>
              {this.state.error?.message?.slice(0, 200) || "Erro inesperado."}
            </p>
            <div style={{ marginTop: 12, display: "flex", gap: 8, justifyContent: "center" }}>
              <button
                onClick={this.handleReset}
                data-testid="error-boundary-retry"
                style={{
                  padding: "8px 16px", borderRadius: 999,
                  background: "#0f172a", color: "#fff",
                  border: 0, cursor: "pointer", fontSize: 14,
                }}
              >
                Tentar novamente
              </button>
              <button
                onClick={() => (window.location.href = "/feed")}
                style={{
                  padding: "8px 16px", borderRadius: 999,
                  background: "transparent", color: "#0f172a",
                  border: "1px solid #0f172a", cursor: "pointer", fontSize: 14,
                }}
              >
                Voltar para o feed
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
